<script>
export default {
  inject: [
    'commonStore',
    'accountsStore'
  ],

  data () {
    return {
    }
  },

  computed: {
  },

  methods: {
  },

  created () {
  }
}

</script>

<template>
  <main class="error column items-center justify-center">
    ERROR
  </main>
</template>

<style scoped lang="scss">
main.error {
  flex: 1;
}
</style>